import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { IDotMenu } from '@app/models';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    children: React.ReactNode;
    partiallySelected: boolean;
    selectAll: boolean;
    selectedItemsCount: string;
    actionMenuItems?: IDotMenu[];
}

export function TableCheckboxMenu({ children, actionMenuItems, partiallySelected, selectAll, selectedItemsCount }: IProps) {
    const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(menuAnchorEl);
    const isActionMenuVisible = !!(actionMenuItems?.length && (partiallySelected || selectAll));
    const { translation } = useTypedTranslation();

    const handleClick = (isActionMenuActive: boolean) => (e: any) => {
        isActionMenuActive && e.target.name !== 'selectall' && setMenuAnchorEl(e.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleMenuClick = (option: IDotMenu) => (e: React.MouseEvent) => {
        handleMenuClose();
        option.action(e);
    };

    return (
        <>
            <div
                className={`checkboxAll__wrapper ${isActionMenuVisible ? 'checkboxAll__wrapper-active' : ''} ${
                    menuAnchorEl ? 'checkboxAll__wrapper-with-dropdown' : ''
                }`}
                onClick={handleClick(isActionMenuVisible)}
            >
                {children}
                {isActionMenuVisible ? <i className='fa-solid fa-caret-down' /> : null}
            </div>
            <Menu
                id='id'
                className='checkboxAll__dropdown'
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                getContentAnchorEl={null}
                anchorEl={menuAnchorEl}
                keepMounted
                open={open}
                onClose={handleMenuClose}
            >
                <div>
                    <li className='checkboxAll__menu-helper'>
                        <b>{selectedItemsCount}</b> {translation('SELECTED_LOWERCASE')}
                    </li>
                    {actionMenuItems?.map((menuItem, index) => (
                        <div key={menuItem.name + index}>
                            {(menuItem.permitted === undefined || menuItem.permitted) && (
                                <>
                                    {menuItem.isDeleteAction ? (
                                        <MenuItem
                                            id='actionMenu'
                                            disableRipple={true}
                                            className={'checkboxAll__dropdown-divider'}
                                            onClick={handleMenuClick(menuItem)}
                                        />
                                    ) : null}
                                <MenuItem
                                    id='actionMenu'
                                    disableRipple={true}
                                    className={menuItem.isDeleteAction ? 'checkboxAll__dropdown-footer' : ''}
                                    onClick={handleMenuClick(menuItem)}
                                >
                                    {menuItem.name}
                                </MenuItem>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </Menu>
        </>
    );
}
